export const caPostalCodeTemplates = [/^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i];

export const usPostalCodeTemplates = [/^[0-9]{5}$/i, /^[0-9]{5}-[0-9]{4}$/i];
